/**
 * 국내 은행 목록 — 환불 계좌 입력용. 쇼핑몰 `storefront/src/features/catalog/components/krBanks.ts` 와 같은 목록·코드다.
 *
 * 코드는 금융결제원 3자리(예: 004 KB국민, 088 신한). 결제 환불 API(payment-service)는 이 3자리를 받아 Toss 코드로
 * 바꿔 보낸다(TossBankCodes). 고객이 쇼핑몰에서 클레임에 남긴 환불 계좌도 같은 코드라, 클레임 계좌를 그대로 채울 수 있다.
 */
export interface KrBankOption {
  readonly code: string;
  readonly name: string;
}

export const KR_BANKS: readonly KrBankOption[] = [
  { code: '004', name: 'KB국민은행' },
  { code: '088', name: '신한은행' },
  { code: '020', name: '우리은행' },
  { code: '081', name: '하나은행' },
  { code: '011', name: 'NH농협은행' },
  { code: '003', name: 'IBK기업은행' },
  { code: '090', name: '카카오뱅크' },
  { code: '089', name: '케이뱅크' },
  { code: '092', name: '토스뱅크' },
  { code: '023', name: 'SC제일은행' },
  { code: '027', name: '한국씨티은행' },
  { code: '032', name: '부산은행' },
  { code: '039', name: '경남은행' },
  { code: '034', name: '광주은행' },
  { code: '037', name: '전북은행' },
  { code: '035', name: '제주은행' },
  { code: '031', name: '대구은행' },
  { code: '002', name: '산업은행' },
  { code: '007', name: '수협은행' },
  { code: '071', name: '우체국예금보험' },
  { code: '045', name: '새마을금고' },
  { code: '048', name: '신협' },
  { code: '050', name: '저축은행' },
];

export const krBankName = (code: string | null | undefined): string | null =>
  KR_BANKS.find((b) => b.code === code)?.name ?? null;

/** 계좌번호에서 숫자만 남긴다(하이픈·공백 제거). BE 도 숫자만 남기지만 보내기 전에 맞춰 둔다. */
export const accountDigits = (value: string): string => value.replace(/\D/g, '');
